import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Exportar Arquivo de Identificação de Estudantes',
    path: '/censoescolar/manutencao',
    name: 'censo_exportar_dados',
    component: () => import('@/views/censoescolar/manutencao/ExportarArquivoIdentificacao.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Importar Arquivo de Atualização do Código INEP',
    path: '/censoescolar/manutencao',
    name: 'censo_importar_dados',
    component: () => import('@/views/censoescolar/manutencao/ImportarDadosINEP.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    // [CENSO] Painel da REDE das pendências do Censo (1ª e 2ª etapa). Path próprio (antes dividia o
    // path com as telas de identificação). O NOME da rota foi mantido: é ele que liga o item de menu.
    description: 'Monitoramento de Pendências',
    path: '/censoescolar/manutencao/monitoramento',
    name: 'censo_monitoramento',
    component: () => import('@/views/censoescolar/manutencao/Monitoramento.vue'),
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.MONITORAMENTO_PENDENCIAS_CENSO_NOVO_300800530],
    },
    goesToMenu: true,
  },
]

